<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="row">
    <div class="col-12">
      <app-card cardTitle="Filtros" [options]="false">
        <div class="row">
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Data Inicio</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Data Fim</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Status</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Cliente</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Tipo</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Responsável</label>
            <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
          </div>
          <div class="col-sm-12 col-xl-4 ">
            <br>
            <button type="button" class="btn btn-success " (click)="salvar()"  style="margin-top: 6px;">Pesquisar &nbsp;<i
                class="feather icon-check-circle"></i>
            </button>
            &nbsp;&nbsp;&nbsp;
         
          </div>
        </div>
  
  
  
      </app-card>
    </div>
    <div class="col-12">
      <app-card cardTitle="Auditoria" blockClass="table-border-style" [options]="false">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nível</th>
                <th>Status</th>
                <th>Cliente</th>
                <th>Tipo</th>
                <th>DataInicio</th>
                <th>DataFim</th> 
                <th>Andamento</th>
                <th>Responsavel</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of arrayTurma">
                <td>{{item.nivel }}</td>
                <td>{{item.status }}</td>
                <td>{{item.cliente }}</td>
                <td>{{item.tipo }}</td>
                <td>{{item.dataInicio | date: 'dd/MM/yyyy' }}</td>
                <td>{{item.dataFim | date: 'dd/MM/yyyy' }}</td>
                <td>{{item.andamento }}</td>
                <td>{{item.responsavel }}</td>
                <td>
                  <button type="button" class="btn btn-icon btn-info " [placement]="'top'" ngbTooltip="Cronograma" (click)="carregarEdicao(item)">
                    <i class="fa fa-calendar"></i>
                  </button>   
                  &nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-warning " [placement]="'top'" ngbTooltip="Relatório Final" (click)="desabilitar(item.id)">
                    <i class="feather icon-activity"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
  </div>
  